import { Box,  Paper, Stack, Typography } from "@mui/material";
import React from "react";
import Grid from '@mui/material/Grid2';
import coin from '../../assets/partner/coins.png'
import users from '../../assets/partner/users.png'
import cash from '../../assets/serve/cash-register-purple.png'

const featureData = [
  {
    icon: coin,
    title: "MONETIZE YOUR NETWORK",
    description: [
      "LEVERAGE YOUR",
      "CONNECTIONS TO EARN",
      "GENEROUS COMMISSIONS",
    ],
  },
  {
    icon: cash,
    title: "CUSTOM REWARDS",
    description: [
      "FLEXIBLE COMPENSATION",
      "DESIGNED FOR YOUR",
      "BUSINESS MODEL",
    ],
  },
  {
    icon: users,
    title: "PROFESSIONAL SUPPORT",
    description: [
      "OUR TEAM IS HERE TO ASSIST",
      "YOU WITH THE TOOLS, INSIGHTS,",
      "AND GUIDANCE YOU NEED TO SUCCEED",
    ],
  },
];

const WhyPartner = () => {
  return (
    <Stack spacing={8} sx={{
        display: "flex",
        maxWidth: "1320px",
        margin: "0 auto",
        alignItems: "flex-start",
        flexDirection: "column",
        alignSelf: "stretch",
        width: "100%",  
        px: 1.5
    }}>
      <Typography variant="subtitle8" sx={{
        textTransform: "uppercase",
        color: "darkPurple.500"
      }}>
        <Box component="span">
          Why {" "}
        </Box>
        <Box component="span" color="lightPurple.500">
          partner
        </Box>
        <Box component="span">
          {" "}
          with EPAYR?
        </Box>
      </Typography>

      <Paper
        elevation={0}
        sx={{
          bgcolor: "gray.200",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-start",
          gap: {md: "50px", xs: "8px"},
          alignSelf: "stretch",
          marginTop: "32px !important",
        }}
      >
        <Grid container spacing={4} sx={{
            display: "flex",
            flexDirection: {md: "row", xs: "column"},
            gap: "28px",
            alignSelf: "stretch",
            alignItems: {xs: "flex-start", md: "flex-end"},
            padding: {md: "40px", xs: "32px 20px"},
        }}>
          {featureData.map((feature, index) => (
            <Grid size={{xs: 12, md: 4}} key={index}>
              <Stack spacing={4} sx ={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                alignSelf: "stretch",
                gap: {md: "32px", xs: "20px"},
                flex: "1 0 0",
              }}>
                <Box
                  sx={{
                    width: {md: "48px", xs: "44px"},
                    height: {md: "48px", xs: "44px"},
                    bgcolor: "lime.100",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    aspectRatio: "1/1",
                  }}
                >
                    <Box component="img" src={feature.icon} sx={{
                        width: {md: "32px", xs: "24px"},
                        height: {md: "32x", xs: "24px"},
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                        gap: "0px",
                        display: "flex",
                    }}/>
                </Box>
                <Stack sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: {md: "16px", xs: "12px"},
                    marginTop: "0px !important",
                    overflow: "hidden"
                }}>
                  <Typography variant="subtitle11" color="darkPurple.500">
                    {feature.title}
                  </Typography>
                  <Typography variant="body7" color="gray.400" sx={{
                    textWrap: "nowrap",
                  }}>
                    {feature.description.map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        {i < feature.description.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Stack>
  );
};

export default WhyPartner;
